/**
 * Харьцангуй зураг/файлын замд нэмэгдэх нийтийн суурь.
 * Ангилалын icon зэрэг /uploads/... нь ихэвчлэн backend (NEXT_PUBLIC_API_URL) дээр байдаг.
 */
export function getApiBaseUrl() {
  const raw =
    (typeof process !== "undefined" &&
      (process.env.NEXT_PUBLIC_MEDIA_URL?.trim() ||
        process.env.NEXT_PUBLIC_ASSET_BASE_URL?.trim() ||
        process.env.NEXT_PUBLIC_API_URL?.trim() ||
        process.env.NEXT_PUBLIC_PARTNER_WEB_URL?.trim() ||
        process.env.NEXT_PUBLIC_BASE_URL?.trim())) ||
    "";
  return raw.replace(/\/+$/, "");
}
